import { loadScript  } from "./settings-loader.js";
const IMA_SDK_URL = "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
let imaLoadedPromise = null;

export function injectCleonStylesAndWait() {
  const origin = window.location.origin;
  const isLocal = origin.includes("localhost") || origin.includes("127.0.0.1");

  const basePath = isLocal
    ? `${origin}/video-app/embed/assets/css`
    : `https://video.cleon.tv/embed/assets/css`;

  const cssFiles = [
    `${basePath}/app.css`,
    `${basePath}/video-js.min.css`,
    `${basePath}/videojs.ima.css`,
  ];

  const loads = cssFiles.map((href) => new Promise((resolve) => {
    const existing = [...document.querySelectorAll('link[rel="stylesheet"]')]
      .find(l => l.href === href);

    if (existing && existing.sheet) return resolve();

    const link = existing || document.createElement("link");
    if (!existing) {
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    }

    link.addEventListener("load", resolve, { once: true });
    link.addEventListener("error", resolve, { once: true });
  }));

  return Promise.all(loads);
}

export function ensureImaSdk() {
    if (!imaLoadedPromise) {
        imaLoadedPromise = loadScript(IMA_SDK_URL);
    }
    return imaLoadedPromise;
}

